export default __webpack_public_path__ + "static/media/ic_shuttles_off.55030391.svg";